import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled';
import { Text } from '@lightspeed/flame/Text';

import { ButtonBaseTile, ButtonBaseTileProps } from '~/renderer/components/UI/ButtonBaseTile';
import { ROUTE_TIPPING_FLOW_INPUT } from '~/renderer/routes';
import { isTippingAvailable } from '~/renderer/store/receipt/selectors';

import type { AppState } from '~/renderer/store/types';

const ButtonTile = styled(ButtonBaseTile)<ButtonBaseTileProps>`
  position: absolute;
  bottom: 40px;
`;

export const ConfirmSaleButton: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const canTip = useSelector<AppState, boolean>(isTippingAvailable);
  const history = useHistory();

  if (!canTip) {
    return null;
  }

  const navigateToTipping = () => {
    window.scrollTo(0, 0);
    history.push(ROUTE_TIPPING_FLOW_INPUT);
  };

  return (
    <ButtonTile
      aria-label="confirm-order-btn"
      data-testid="confirm-order-btn"
      onClick={navigateToTipping}
      fullWidth={true}
    >
      <Text size="large">{t('receipt.tipping.confirmOrder')}</Text>
    </ButtonTile>
  );
};
